import { render } from "./temExport.vue?vue&type=template&id=4a2038e9"
import script from "./temExport.vue?vue&type=script&lang=js"
export * from "./temExport.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__